.keyart {
	background: #fff url("/images/home/4-RLSS-Hero-Mobile.png") no-repeat top center;
	background-size: contain;

	.keyartInner {
		background: url("/images/home/RLS-Hero-Mobile--bottom.png") no-repeat bottom center;
		background-size: cover;
		padding-top: 94%;

		.downloadButtons {
			.downloadButton {
				img {
					width: 100%;
				}
			}
		}

		.playTrailerWrap {
			button {
				background: #ff750a;
				background: linear-gradient(to bottom, #ff750a 0, #ffd854 100%);
				margin: 8% 0 24%;
				transform: skew(-30deg);
				filter: drop-shadow(5px 5px #000);
				span {
					font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
					transform: skew(30deg);
				}
			}
		}

		.downArrowWrap {
			img {
				width: 17.5vw;
				margin-top: 15%;
				margin-bottom: 12%;
			}
		}

		.moreNewsWrap {
			.readmoreButton {
				background: #0165f7;
				margin: 8% 0 24%;
				//transform: skewX(-25deg);
				border-radius: 8px;
				border: 2px solid #27a4f0;
				a {
					span {
						font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
						font-weight: 700;
						color: #fff;
						//transform: skewX(25deg);
						display: block;
					}
				}
			}
		}
	}
}

@media screen and (min-width: 768px) {
	.keyart {
		background: #fff url("/images/home/3-RLSS-Hero-Tablet.png") no-repeat top center;
		background-size: contain;
		.keyartInner {
			padding-top: 64%;
			.playTrailerWrap {
				button {
					margin: 1% 0 14%;
				}
			}

			.downloadButtons {
				.downloadButton {
					img {
						max-width: 20vw;
					}
				}
			}

			.downArrowWrap {
				img {
					width: 8.5vw;
					margin-top: 0;
					margin-bottom: 15%;
				}
			}

			.moreNewsWrap {
				.readmoreButton {
					margin: 4% 0 8%;
				}
			}
		}
	}
}

@media screen and (min-width: 1024px) {
	.keyart {
		background: none;

		.keyartInner {
			padding: 0;
			background: none;
			.pWrap {
				padding-top: 35%;
				padding-bottom: 2.5%;
				.playTrailerWrap {
					button {
						margin: 0% 0 5%;
					}
				}

				.downloadButtons {
					.downloadButton {
						cursor: pointer;
					}
				}

				.downArrowWrap {
					img {
						width: 4vw;
						margin-bottom: 5%;
					}
				}

				.featuredBg {
					background: none;
				}

				.moreNewsWrap {
					.readmoreButton {
						background: #0165f7;
						margin: 0;
						//transform: skewX(-25deg);
						border-radius: 8px;
						border: 2px solid #27a4f0;
						a {
							span {
								font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
								font-weight: 700;
								color: #fff;
								//transform: skewX(25deg);
								display: block;
							}
						}
					}
				}
			}
		}
	}
}
